import React from "react";
import { Box, Flex, Text, IconButton } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

/** Liste ordonnée des images produit : main_image en premier, puis les images projet. */
export function buildProductImagesList(project: any): string[] {
  const mainUrl =
    project?.data?.main_image && project.data.main_image.link && typeof project.data.main_image.link === "string"
      ? project.data.main_image.link
      : typeof project?.data?.main_image === "string"
        ? project.data.main_image
        : null;
  const others = project?.images || project?.data?.images || [];
  return mainUrl ? [mainUrl, ...others.filter((u: string) => u !== mainUrl)] : [...others];
}

interface ProductImageCarouselProps {
  project: any;
  currentIndex: number;
  onIndexChange: (index: number) => void;
  height?: string;
  t: (key: string) => string;
}

const ProductImageCarousel: React.FC<ProductImageCarouselProps> = ({
  project,
  currentIndex,
  onIndexChange,
  height = "350px",
  t,
}) => {
  const imageList = buildProductImagesList(project);

  if (imageList.length === 0) {
    return (
      <Flex h={height} align="center" justify="center" bg="whiteAlpha.50" borderRadius="md">
        <Text color="gray.500">{t("noImage") || "Aucune image"}</Text>
      </Flex>
    );
  }

  const idx = Math.min(currentIndex, imageList.length - 1);
  const src = imageList[idx];

  const goPrev = () => onIndexChange(currentIndex <= 0 ? imageList.length - 1 : currentIndex - 1);
  const goNext = () => onIndexChange(currentIndex >= imageList.length - 1 ? 0 : currentIndex + 1);

  return (
    <Box position="relative">
      <img
        key={src}
        src={src}
        alt={`${project?.data?.title || project?.name || "Project"} – ${idx + 1}/${imageList.length}`}
        height={height}
        width="100%"
        style={{ objectFit: "contain" }}
        loading="lazy"
      />
      {imageList.length > 1 && (
        <>
          <IconButton
            aria-label={t("previousImage") || "Image précédente"}
            icon={<ChevronLeftIcon />}
            size="sm"
            position="absolute"
            left={2}
            top="50%"
            transform="translateY(-50%)"
            onClick={goPrev}
            bg="blackAlpha.600"
            _hover={{ bg: "blackAlpha.800" }}
            color="white"
          />
          <IconButton
            aria-label={t("nextImage") || "Image suivante"}
            icon={<ChevronRightIcon />}
            size="sm"
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            onClick={goNext}
            bg="blackAlpha.600"
            _hover={{ bg: "blackAlpha.800" }}
            color="white"
          />
          <Text
            position="absolute"
            bottom={2}
            left="50%"
            transform="translateX(-50%)"
            fontSize="xs"
            color="white"
            bg="blackAlpha.600"
            px={2}
            py={1}
            borderRadius="md"
          >
            {idx + 1} / {imageList.length}
          </Text>
        </>
      )}
    </Box>
  );
};

export default ProductImageCarousel;
